import React from 'react';
import { useBoolean } from 'react-use-boolean';
import tourModeIcon from '../../assets/img/TourMode.svg';
import { Dialog } from '../common/Dialog';
import { IconButton } from '../common/IconButton';
import { useGalleryContext } from './GalleryContext';
import { TourModeModal } from './TourModeModal';

export const TourMode: React.FC = () => {
  const [open, modalActions] = useBoolean();
  const { waypointsShown, setState } = useGalleryContext();

  return (
    <>
      <IconButton
        onClick={modalActions.on}
        variant={'primary'}
        aria-label='Tour Mode Options'
        icon={<img src={tourModeIcon} alt={'Tour Mode'} />}
        style={{ marginRight: 8 }}
      />
      <Dialog open={open} onClose={modalActions.off}>
        <TourModeModal
          initialConfig={waypointsShown}
          onClose={modalActions.off}
          onConfirm={(tourModeConfig) => {
            setState((prevState) => ({ ...prevState, waypointsShown: tourModeConfig }));
            modalActions.off();
          }}
          cancelButtonLabel={'Cancel'}
          confirmButtonLabel={'Confirm'}
        />
      </Dialog>
    </>
  );
};
